import { ACCESS_TOKEN } from "@/constants/common";
import { localStorageService } from "@/utils/localStorage";
import axios from "axios";

export const requestUploadFile = async (id, fileExt, uploadFile) => {
  const token = localStorageService.getItem(ACCESS_TOKEN);

  const resp = await axios.post(
    `${import.meta.env.VITE_APP_API_URL +
    "/api/upload-url?type={/type}&id={/id}&suffix={/timestamp}&ext={/fileExt}"
      .replace("{/id}", id)
      .replace("{/timestamp}", Date.now().toString())
      .replace("{/fileExt}", fileExt)
      .replace("{/type}", 'ece')
    }`, null,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  const { filename, uploadUrl } = resp.data;
  await axios.put(uploadUrl, uploadFile);
  return { filename, uploadUrl };
};
